import React from "react";
import {
  Col,
  Image,
  Row,
  Button,
  //   theme,
} from "antd";
import InvoiceLogo from "../../assets/images/invoice.webp";

const Invoice = () => {
  return (
    <Col span={24} className="mt-40">
      <Row>
        <Col span={10}>
          <h1 className="leading-tight text-start text-[#314259] text-[48px] font-extrabold">
            GST Billing Software in India for Small Businesses
          </h1>
          <p className="mt-6 text-start text-[#787878] text-[20px] font-semibold">
            Manage your business professionally with Mbook. Using the best
            software for your billing, inventory & accounting needs. Be a part
            of 1 lac+ SMEs in India who trust Mbook.{" "}
          </p>
        </Col>
        <Col span={14}>
          <Image src={InvoiceLogo} height={350} preview={false} />
        </Col>
      </Row>
      <div className="text-start mt-5">
        <Button className="text-[white] download-btn p-5 bg-[#ed1a3b]">
          Download Mbook Now
        </Button>
      </div>
    </Col>
  );
};
export default Invoice;
